export const GUIDES = {
  evacuacion: {
    id: "evacuacion",
    icon: "Route",
    image: "https://images.pexels.com/photos/15306044/pexels-photo-15306044.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: { es: "Planes de Evacuación", en: "Evacuation Plans" },
    subtitle: {
      es: "Protocolos paso a paso para terremotos, inundaciones y huracanes, con planificación de rutas y comunicación familiar.",
      en: "Step-by-step protocols for earthquakes, floods and hurricanes, with route planning and family communications.",
    },
    chapters: [
      {
        title: { es: "Terremotos: reacción inmediata", en: "Earthquakes: immediate response" },
        intro: {
          es: "Puerto Rico es sísmicamente activa. La clave es reaccionar en segundos y evacuar solo cuando sea seguro.",
          en: "Puerto Rico is seismically active. The key is reacting in seconds and evacuating only when safe.",
        },
        steps: [
          { es: "Durante el temblor: agáchese, cúbrase y agárrese bajo un mueble sólido.", en: "During shaking: drop, cover, and hold on under solid furniture." },
          { es: "Aléjese de ventanas, estanterías y paredes exteriores.", en: "Stay away from windows, shelves and exterior walls." },
          { es: "No use ascensores ni salga corriendo durante el movimiento.", en: "Do not use elevators or run outside during shaking." },
          { es: "Al terminar: cierre el gas si huele fuga y revise grietas estructurales.", en: "Afterwards: shut off gas if you smell a leak and check for structural cracks." },
          { es: "Si está cerca de la costa, muévase a terreno alto por posible tsunami.", en: "If near the coast, move to high ground for possible tsunami." },
          { es: "Espere réplicas; mantenga zapatos y linterna junto a la cama.", en: "Expect aftershocks; keep shoes and a flashlight by the bed." },
        ],
      },
      {
        title: { es: "Tsunami: guía para zonas costeras", en: "Tsunami: coastal zone guidance" },
        intro: {
          es: "La costa norte de PR puede recibir un tsunami en minutos tras un sismo. Si vive o visita uno de los 44 municipios costeros, conozca su zona de evacuación.",
          en: "PR's north coast can be hit by a tsunami within minutes of an earthquake. If you live in or visit one of the 44 coastal towns, know your evacuation zone.",
        },
        steps: [
          { es: "Un sismo FUERTE cerca de la costa es la señal: no espere la alerta, aléjese del mar de inmediato.", en: "A STRONG quake near the coast is the signal: don't wait for the alert, move away from the sea immediately." },
          { es: "Camine o corra a terreno alto (100+ pies de elevación o 1 milla tierra adentro). No use el auto: las calles costeras colapsan.", en: "Walk or run to high ground (100+ ft elevation or 1 mile inland). Don't drive: coastal roads gridlock." },
          { es: "Si no llega a terreno alto, suba a un edificio de hormigón de 3+ pisos (evacuación vertical).", en: "If you can't reach high ground, go up a concrete building 3+ stories (vertical evacuation)." },
          { es: "Un aviso de tsunami del NWS activará la sirena y el banner rojo en la pestaña Clima, además de las alertas WEA del celular y la radio.", en: "An NWS tsunami alert will trigger the siren and red banner in the Weather tab, plus cell phone WEA alerts and radio." },
          { es: "No regrese a la costa hasta el aviso oficial: los tsunamis llegan en varias olas durante horas y la primera no siempre es la mayor.", en: "Don't return to the coast until the official all-clear: tsunamis arrive in multiple waves over hours, and the first is not always the largest." },
          {
            es: "Municipios costeros con zonas de evacuación (verifique su mapa oficial en la Red Sísmica de PR o NMEAD): Aguada, Aguadilla, Añasco, Arecibo, Arroyo, Barceloneta, Cabo Rojo, Camuy, Canóvanas, Carolina, Cataño, Ceiba, Culebra, Dorado, Fajardo, Guánica, Guayama, Guayanilla, Guaynabo, Hatillo, Humacao, Isabela, Juana Díaz, Lajas, Loíza, Luquillo, Manatí, Maunabo, Mayagüez, Naguabo, Patillas, Peñuelas, Ponce, Quebradillas, Rincón, Río Grande, Salinas, San Juan, Santa Isabel, Toa Baja, Vega Alta, Vega Baja, Vieques y Yabucoa.",
            en: "Coastal municipalities with evacuation zones (check the official map from the PR Seismic Network or NMEAD): Aguada, Aguadilla, Añasco, Arecibo, Arroyo, Barceloneta, Cabo Rojo, Camuy, Canóvanas, Carolina, Cataño, Ceiba, Culebra, Dorado, Fajardo, Guánica, Guayama, Guayanilla, Guaynabo, Hatillo, Humacao, Isabela, Juana Díaz, Lajas, Loíza, Luquillo, Manatí, Maunabo, Mayagüez, Naguabo, Patillas, Peñuelas, Ponce, Quebradillas, Rincón, Río Grande, Salinas, San Juan, Santa Isabel, Toa Baja, Vega Alta, Vega Baja, Vieques and Yabucoa.",
          },
        ],
      },
      {
        title: { es: "Inundaciones severas", en: "Severe floods" },
        intro: {
          es: "Las inundaciones repentinas son la causa principal de muerte en eventos atmosféricos en PR.",
          en: "Flash flooding is the leading cause of death in weather events in PR.",
        },
        steps: [
          { es: "Nunca cruce corrientes de agua a pie ni en vehículo: 6 pulgadas tumban a una persona.", en: "Never cross moving water on foot or by car: 6 inches can knock a person down." },
          { es: "Si el agua sube en casa, suba al nivel más alto, no al techo cerrado.", en: "If water rises indoors, move to the highest level, not an enclosed roof." },
          { es: "Desconecte el breaker principal si el agua entra al hogar.", en: "Switch off the main breaker if water enters the home." },
          { es: "Evite ríos crecidos, quebradas y puentes bajos conocidos en su zona.", en: "Avoid swollen rivers, creeks and known low bridges in your area." },
          { es: "Tras la inundación, no beba agua de la pluma sin tratarla.", en: "After flooding, do not drink tap water without treatment." },
        ],
      },
      {
        title: { es: "Huracanes: cuándo y cómo evacuar", en: "Hurricanes: when and how to evacuate" },
        intro: {
          es: "La decisión de evacuar se toma ANTES de que lleguen los vientos. Siga las órdenes de NMEAD.",
          en: "The decision to evacuate is made BEFORE the winds arrive. Follow NMEAD orders.",
        },
        steps: [
          { es: "Evacúe si vive en zona inundable, zona costera o estructura vulnerable.", en: "Evacuate if you live in a flood zone, coastal area or vulnerable structure." },
          { es: "Salga temprano: cuando NMEAD ordena, no cuando el viento empieza.", en: "Leave early: when NMEAD orders, not when the wind starts." },
          { es: "Lleve su mochila de emergencia, documentos y medicamentos.", en: "Bring your go-bag, documents and medications." },
          { es: "Confirme el refugio municipal abierto llamando a su OMME o al 787-724-0124.", en: "Confirm open municipal shelters via your OMME or 787-724-0124." },
          { es: "Si se queda en casa: cuarto interior, sin ventanas, en la planta baja.", en: "If sheltering at home: interior room, no windows, lowest floor." },
        ],
      },
      {
        title: { es: "Planificación de rutas", en: "Route planning" },
        intro: {
          es: "Las carreteras principales colapsan. Planifique alternativas antes de la temporada.",
          en: "Main roads collapse under pressure. Plan alternatives before the season.",
        },
        steps: [
          { es: "Trace dos rutas hacia su refugio y dos hacia su punto de encuentro familiar.", en: "Map two routes to your shelter and two to your family meet-up point." },
          { es: "Descargue mapas offline de su municipio en el celular.", en: "Download offline maps of your municipality to your phone." },
          { es: "Identifique puentes y zonas que se inundan en lluvias fuertes.", en: "Identify bridges and spots that flood in heavy rain." },
          { es: "Guarde un mapa de papel en la guantera del vehículo.", en: "Keep a paper map in the vehicle glovebox." },
        ],
      },
      {
        title: { es: "Protocolo de comunicación familiar", en: "Family communications protocol" },
        intro: {
          es: "Las redes celulares se saturan. Un plan escrito evita el pánico.",
          en: "Cell networks saturate. A written plan prevents panic.",
        },
        steps: [
          { es: "Designe un contacto fuera de Puerto Rico como punto central de reportes.", en: "Designate an out-of-island contact as the central check-in point." },
          { es: "Use mensajes de texto: consumen menos red que las llamadas.", en: "Use text messages: they use less network than calls." },
          { es: "Acuerde horarios fijos de reporte (ej. 8am y 6pm).", en: "Agree on fixed check-in times (e.g., 8am and 6pm)." },
          { es: "Escriba los teléfonos clave en papel para cada familiar.", en: "Write key phone numbers on paper for every family member." },
          { es: "Tenga una radio de baterías o manivela para noticias oficiales.", en: "Keep a battery or crank radio for official news." },
        ],
      },
    ],
  },
  agua: {
    id: "agua",
    icon: "Droplets",
    image: null,
    title: { es: "Agua y Cisternas", en: "Water & Cisterns" },
    subtitle: {
      es: "Cosecha de agua de lluvia, desinfección de cisternas y purificación para sobrevivir fuera de la red.",
      en: "Rainwater harvesting, cistern disinfection and purification for off-grid survival.",
    },
    chapters: [
      {
        title: { es: "Cosecha de agua de lluvia", en: "Rainwater harvesting" },
        intro: {
          es: "El techo de una casa típica puede captar cientos de galones por pulgada de lluvia.",
          en: "A typical home roof can capture hundreds of gallons per inch of rain.",
        },
        steps: [
          { es: "Dirija bajantes del techo hacia la cisterna con canales limpios.", en: "Direct roof downspouts into the cistern with clean gutters." },
          { es: "Instale un sistema de 'primer lavado' para descartar el agua inicial sucia.", en: "Install a first-flush diverter to discard dirty initial runoff." },
          { es: "Use mallas contra hojas y mosquitos en todas las entradas.", en: "Use mesh against leaves and mosquitoes at all inlets." },
          { es: "Calcule: 1 galón por persona por día para beber; 3-5 con higiene.", en: "Calculate: 1 gallon per person per day for drinking; 3-5 with hygiene." },
        ],
      },
      {
        title: { es: "Desinfección de la cisterna", en: "Cistern disinfection" },
        intro: {
          es: "Desinfecte cada 6 meses o después de cualquier inundación o entrada de agua turbia.",
          en: "Disinfect every 6 months or after any flooding or turbid water entry.",
        },
        steps: [
          { es: "Vacíe y frote las paredes con cepillo y solución de cloro.", en: "Drain and scrub walls with a brush and chlorine solution." },
          { es: "Use cloro regular sin perfume: 1 taza por cada 100 galones para choque inicial.", en: "Use plain unscented bleach: 1 cup per 100 gallons for initial shock." },
          { es: "Deje reposar 12 horas y enjuague antes de usar para consumo.", en: "Let sit 12 hours and rinse before drinking use." },
          { es: "Pruebe la bomba y revise sellos y tapa hermética.", en: "Test the pump and check seals and the watertight lid." },
        ],
      },
      {
        title: { es: "Purificación para beber", en: "Purification for drinking" },
        intro: {
          es: "Ante la duda, trate el agua. Estos métodos son respaldados por el CDC y la EPA.",
          en: "When in doubt, treat the water. These methods are backed by the CDC and EPA.",
        },
        steps: [
          { es: "Hierva el agua 1 minuto a fuego fuerte (método más seguro).", en: "Boil water for 1 minute at a rolling boil (safest method)." },
          { es: "Cloro: 2 gotas de cloro sin perfume por litro; espere 30 minutos.", en: "Bleach: 2 drops of unscented bleach per liter; wait 30 minutes." },
          { es: "Pastillas purificadoras: siga la dosis del fabricante.", en: "Purification tablets: follow the manufacturer's dose." },
          { es: "Filtros de gravedad tipo cerámica eliminan sedimentos y bacterias.", en: "Ceramic gravity filters remove sediment and bacteria." },
          { es: "Almacene en envases limpios, cerrados y lejos del sol.", en: "Store in clean, sealed containers away from sunlight." },
        ],
      },
      {
        title: { es: "Conservación durante la sequía", en: "Conservation during drought" },
        intro: {
          es: "Estire cada galón cuando AAA raciona el servicio.",
          en: "Stretch every gallon when AAA rations service.",
        },
        steps: [
          { es: "Reúse el agua de enjuague para inodoros y limpieza.", en: "Reuse rinse water for toilets and cleaning." },
          { es: "Baños cortos con cubo en vez de ducha corrida.", en: "Short bucket baths instead of running showers." },
          { es: "Marque el nivel de la cisterna y lleve un registro semanal.", en: "Mark the cistern level and keep a weekly log." },
          { es: "Localice su oasis de AAA más cercano: 1-877-523-7252.", en: "Locate your nearest AAA water point: 1-877-523-7252." },
        ],
      },
    ],
  },
  energia: {
    id: "energia",
    icon: "Zap",
    image: "https://images.unsplash.com/photo-1650785652040-5a2fc88ce902?crop=entropy&cs=srgb&fm=jpg&q=85",
    title: { es: "Energía y Plantas", en: "Power & Generators" },
    subtitle: {
      es: "Operación segura de generadores, prevención de monóxido de carbono y estrategias para apagones prolongados.",
      en: "Safe generator operation, carbon monoxide prevention and strategies for prolonged blackouts.",
    },
    chapters: [
      {
        title: { es: "Seguridad contra monóxido de carbono", en: "Carbon monoxide safety" },
        intro: {
          es: "El CO mata sin olor ni aviso. Después de cada huracán, PR registra intoxicaciones por mal uso de plantas.",
          en: "CO kills without smell or warning. After every hurricane, PR records poisonings from generator misuse.",
        },
        steps: [
          { es: "NUNCA opere la planta dentro del hogar, garaje o marquesina.", en: "NEVER run a generator indoors, in a garage or carport." },
          { es: "Ubíquela a 20+ pies de puertas, ventanas y extractores, con escape hacia afuera.", en: "Place it 20+ feet from doors, windows and vents, exhaust facing away." },
          { es: "Instale detectores de CO en cada nivel del hogar.", en: "Install CO detectors on every level of the home." },
          { es: "Síntomas de intoxicación: dolor de cabeza, mareo, náusea. Salga al aire fresco y llame al 911.", en: "Poisoning symptoms: headache, dizziness, nausea. Get fresh air and call 911." },
          { es: "Centro de Envenenamiento: 1-800-222-1222, disponible 24/7.", en: "Poison Control: 1-800-222-1222, available 24/7." },
        ],
      },
      {
        title: { es: "Conexión segura: transferencia y extensiones", en: "Safe hookup: transfer switch & cords" },
        intro: {
          es: "Una mala conexión puede electrocutar a los brigadistas de LUMA y quemar sus equipos.",
          en: "A bad hookup can electrocute LUMA line workers and fry your appliances.",
        },
        steps: [
          { es: "Use un interruptor de transferencia instalado por electricista certificado.", en: "Use a transfer switch installed by a certified electrician." },
          { es: "Nunca conecte la planta directo a un enchufe de la pared ('backfeeding').", en: "Never plug a generator into a wall outlet ('backfeeding')." },
          { es: "Use extensiones de calibre grueso (12-14 AWG) aprobadas para exteriores.", en: "Use heavy-gauge (12-14 AWG) outdoor-rated extension cords." },
          { es: "No sobrecargue: sume los vatios de lo que conecta y deje margen del 20%.", en: "Don't overload: add up the watts and leave a 20% margin." },
        ],
      },
      {
        title: { es: "Mantenimiento programado", en: "Scheduled maintenance" },
        intro: {
          es: "Una planta que no arranca en la emergencia no sirve. Mantenga un calendario.",
          en: "A generator that won't start in an emergency is useless. Keep a schedule.",
        },
        steps: [
          { es: "Mensual: prueba de 15-20 minutos con carga real.", en: "Monthly: 15-20 minute test run under real load." },
          { es: "Cada 50-100 horas: cambio de aceite y revisión de filtro de aire.", en: "Every 50-100 hours: oil change and air filter check." },
          { es: "Cada temporada: bujía nueva, combustible fresco con estabilizador.", en: "Each season: new spark plug, fresh fuel with stabilizer." },
          { es: "Almacene gasolina máximo 30 días sin estabilizador; rótela.", en: "Store gasoline max 30 days without stabilizer; rotate it." },
        ],
      },
      {
        title: { es: "Estrategias para apagones prolongados", en: "Prolonged blackout strategies" },
        intro: {
          es: "Tras María, zonas de PR estuvieron meses sin luz. Planifique por semanas, no por horas.",
          en: "After María, parts of PR went months without power. Plan in weeks, not hours.",
        },
        steps: [
          { es: "Encienda la planta por intervalos (ej. 4 horas) para ahorrar combustible.", en: "Run the generator in intervals (e.g., 4 hours) to save fuel." },
          { es: "Priorice: nevera, equipos médicos, comunicación; lo demás puede esperar.", en: "Prioritize: fridge, medical equipment, communications; the rest can wait." },
          { es: "Considere paneles solares portátiles y baterías para cargas pequeñas.", en: "Consider portable solar panels and batteries for small loads." },
          { es: "Cree una red vecinal: turnos de planta, carga compartida de celulares.", en: "Build a neighborhood network: generator shifts, shared phone charging." },
          { es: "Reporte apagones a LUMA: 1-844-888-5862.", en: "Report outages to LUMA: 1-844-888-5862." },
        ],
      },
    ],
  },
  cuidados: {
    id: "cuidados",
    icon: "HeartPulse",
    image: null,
    title: { es: "Cuidados Especiales", en: "Special Care" },
    subtitle: {
      es: "Guías para adultos mayores, dependencias médicas, niños y salud emocional durante desastres.",
      en: "Guides for seniors, medical dependencies, children and emotional health during disasters.",
    },
    chapters: [
      {
        title: { es: "Adultos mayores", en: "Senior citizens" },
        intro: {
          es: "Las personas mayores son las más vulnerables a apagones y calor extremo.",
          en: "Seniors are the most vulnerable to blackouts and extreme heat.",
        },
        steps: [
          { es: "Inscríbalos en el registro de necesidades especiales de su municipio.", en: "Register them in your municipality's special-needs registry." },
          { es: "Mantenga 30 días de medicamentos y copias de recetas.", en: "Keep 30 days of medications and prescription copies." },
          { es: "Plan de hidratación estricto durante oleadas de calor.", en: "Strict hydration plan during heat waves." },
          { es: "Acuerde visitas o llamadas diarias con vecinos y familia.", en: "Arrange daily check-in visits or calls with neighbors and family." },
          { es: "Departamento de la Familia: 787-625-4900.", en: "Department of the Family: 787-625-4900." },
        ],
      },
      {
        title: { es: "Equipos médicos que usan electricidad", en: "Powered medical equipment" },
        intro: {
          es: "CPAP, oxígeno, diálisis e insulina requieren plan de energía y frío.",
          en: "CPAP, oxygen, dialysis and insulin require power and cooling plans.",
        },
        steps: [
          { es: "Batería de respaldo dedicada para CPAP (mínimo 2 noches).", en: "Dedicated backup battery for CPAP (minimum 2 nights)." },
          { es: "Concentrador de oxígeno: confirme prioridad de restablecimiento con LUMA.", en: "Oxygen concentrator: confirm restoration priority with LUMA." },
          { es: "Insulina: neverita con packs de hielo; descarte si supera temperatura segura.", en: "Insulin: cooler with ice packs; discard if it exceeds safe temperature." },
          { es: "Pregunte a su plan médico por servicios de emergencia post-desastre.", en: "Ask your health plan about post-disaster emergency services." },
        ],
      },
      {
        title: { es: "Niños y bebés", en: "Children and toddlers" },
        intro: {
          es: "Los niños procesan el desastre por la rutina. Manténgala viva.",
          en: "Children process disaster through routine. Keep it alive.",
        },
        steps: [
          { es: "Kit del niño: pañales, fórmula, medicamentos, juguete de confort.", en: "Child kit: diapers, formula, medications, comfort toy." },
          { es: "Explique el plan con calma y juegos de simulación.", en: "Explain the plan calmly with role-play games." },
          { es: "Identificación en la mochila del niño con contactos de emergencia.", en: "ID in the child's backpack with emergency contacts." },
          { es: "Leche materna o fórmula lista para usar si no hay agua segura.", en: "Breast milk or ready-to-use formula if safe water is unavailable." },
        ],
      },
      {
        title: { es: "Apoyo psicológico", en: "Psychological support" },
        intro: {
          es: "La salud mental es parte de la preparación. Pedir ayuda es fortaleza.",
          en: "Mental health is part of preparedness. Asking for help is strength.",
        },
        steps: [
          { es: "Línea PAS de ASSMCA: 1-800-981-0023, 24/7, gratis.", en: "ASSMCA PAS Line: 1-800-981-0023, 24/7, free." },
          { es: "También puede marcar o textear 9-8-8 en crisis emocional.", en: "You can also call or text 9-8-8 in an emotional crisis." },
          { es: "Limite noticias repetitivas; mantenga rutinas de sueño y comida.", en: "Limit repetitive news; keep sleep and meal routines." },
          { es: "Hable con vecinos: la comunidad es la primera red de apoyo.", en: "Talk with neighbors: community is the first support network." },
        ],
      },
    ],
  },
  huertos: {
    id: "huertos",
    icon: "Sprout",
    image: null,
    title: { es: "Huertos y Vehículos", en: "Gardens & Vehicles" },
    subtitle: {
      es: "Seguridad alimentaria con huertos tropicales y vehículos listos para evacuar en minutos.",
      en: "Food security with tropical gardens and vehicles ready to evacuate in minutes.",
    },
    chapters: [
      {
        title: { es: "Huerto casero para seguridad alimentaria", en: "Home garden for food security" },
        intro: {
          es: "El clima tropical de PR permite cosechar todo el año si elige bien.",
          en: "PR's tropical climate allows year-round harvests if you choose well.",
        },
        steps: [
          { es: "Priorice viandas resistentes: plátano, guineo, yuca, batata, ñame.", en: "Prioritize hardy staples: plantain, banana, yuca, sweet potato, yam." },
          { es: "Siembre rápidas: lechuga, recao, ají, espinaca malabar en 30-45 días.", en: "Fast crops: lettuce, recao, peppers, Malabar spinach in 30-45 days." },
          { es: "Use camas elevadas para evitar anegamiento en lluvias fuertes.", en: "Use raised beds to avoid waterlogging in heavy rain." },
          { es: "Guarde semillas criollas en envase hermético y fresco.", en: "Store local heirloom seeds in a sealed, cool container." },
          { es: "Siembre escalonada cada 2 semanas para cosecha continua.", en: "Stagger plantings every 2 weeks for continuous harvest." },
        ],
      },
      {
        title: { es: "Protección antes de la tormenta", en: "Pre-storm protection" },
        intro: {
          es: "24-48 horas antes del viento, su huerto necesita acción.",
          en: "24-48 hours before the wind, your garden needs action.",
        },
        steps: [
          { es: "Pode ramas débiles y coseche todo lo maduro.", en: "Prune weak branches and harvest everything ripe." },
          { es: "Cubra camas con malla o lona asegurada contra viento.", en: "Cover beds with secured mesh or tarp against wind." },
          { es: "Guarde herramientas y objetos sueltos que vuelen.", en: "Store tools and loose objects that could become projectiles." },
          { es: "Desvíe drenaje lejos de las camas de siembra.", en: "Divert drainage away from planting beds." },
        ],
      },
      {
        title: { es: "Recuperación post-tormenta", en: "Post-storm recovery" },
        intro: {
          es: "El huerto rebrota. Plátanos y yuca suelen sobrevivir bajo tierra.",
          en: "Gardens regrow. Plantains and yuca often survive underground.",
        },
        steps: [
          { es: "Retire escombros con guantes; aléjese de cables caídos.", en: "Clear debris with gloves; stay away from downed wires." },
          { es: "Resiembre hortalizas rápidas de inmediato.", en: "Resow fast vegetables immediately." },
          { es: "No consuma cosechas que tocaron agua de inundación.", en: "Do not eat crops that touched floodwater." },
          { es: "Aplique abono orgánico para reactivar el suelo lavado.", en: "Apply organic compost to revive leached soil." },
        ],
      },
      {
        title: { es: "Vehículo listo para evacuar", en: "Evacuation-ready vehicle" },
        intro: {
          es: "Su vehículo es su ruta de escape. Manténgalo en condición de salir en 5 minutos.",
          en: "Your vehicle is your escape route. Keep it ready to leave in 5 minutes.",
        },
        steps: [
          { es: "Tanque siempre sobre la mitad durante temporada de huracanes.", en: "Tank always above half during hurricane season." },
          { es: "Revise mensual: frenos, gomas (incluida la de repuesto), batería y fluidos.", en: "Monthly check: brakes, tires (including spare), battery and fluids." },
          { es: "Kit en el baúl: cables, gato, herramientas, linterna, agua.", en: "Trunk kit: cables, jack, tools, flashlight, water." },
          { es: "Documentos (licencia, registro, seguro) en bolsa impermeable.", en: "Documents (license, registration, insurance) in a waterproof bag." },
          { es: "Cargador de carro y power bank siempre disponibles.", en: "Car charger and power bank always available." },
        ],
      },
    ],
  },
};
